var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSendIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.429412 17.8388L20.5402 9.25059C20.8265 9.10745 20.8265 8.74961 20.5402 8.67804L0.429412 0.0182381C0.214706 -0.0533305 0 0.0898068 0 0.376081L0.429412 6.81726C0.50098 6.9604 0.572549 7.10353 0.715686 7.10353L9.01765 8.67804C9.30392 8.74961 9.30392 9.17902 9.01765 9.25059L0.715686 10.7535C0.572549 10.8251 0.50098 10.8967 0.50098 11.0398L0 17.5526C0 17.7673 0.214706 17.9104 0.429412 17.8388Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSendIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/send-icon.f6afcfc7.svg";
export { ForwardRef as ReactComponent };